<template>
        <div class="leads-main-container">
            <div class="statistics-main-container" style="display: flex; align-items: center; justify-content: center;">
                <div class="demo">
                    <GridStatistics
                    v-for="(statisitc , index) in statisitcs"
                    :key="statisitc.stage"
                    :value="statisitc.total"
                    :label="statisitc.stage"
                    :change="statisitc.percentage"
                    :index="index"
                    :chartColor="colorList[index]"
                    >  
                    </GridStatistics>
                    
                </div>
            </div>
            <div class="leads-main-table">
                
                <div class="table-main-actions-container">
                    <div class="table-actions-container">
                        <div class="row">
                            <div class="sorting-container col-4">
                            <!-- <el-button
                                    type="info"
                                    link
                                    @click="refreshLeads"
                                    >
                                    <font-awesome-icon icon="fa-solid fa-compass-drafting"/> <span style="margin-left:5px;"> All Leads </span>
                            </el-button> -->
                            <el-dropdown>
                                <span class="el-dropdown-link" style="font-weight: bold; margin-top: 6px;">
                                    <font-awesome-icon icon="fa-solid fa-compass-drafting"/>
                                     <span style="font-weight: bold; margin-left: 5px;">{{filterKey}}</span> <el-icon class="el-icon--right"><arrow-down /></el-icon>
                                </span>
                                <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item @click="refreshLeads('all')">
                                        <span style="margin-left:5px;"> All Leads </span>
                                    </el-dropdown-item>
                                    
                                    <el-dropdown-item :icon="CircleCheck" @click="refreshLeads('dupplicated')">Duplicated</el-dropdown-item>
                                </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                            </div>
                            <div class="col-8 table-actions">
                                <ul class="actions-list" >

                                    <li v-if="store.getters['auth/getUserType'] == 'Admin' && selectedLeads.length > 0"><el-button :class="'add-btn assign_btn'" :loading="isExport" type="plain"><font-awesome-icon icon="fa-solid fa-user" /> AssignTo</el-button></li>
                                    <li><el-button v-if="store.getters['auth/getUserRole'] != 'Normal'" :class="'add-btn danger'" type="danger" @click="openAddForm"><font-awesome-icon icon="fa-solid fa-plus"/> Add New</el-button></li>
                                    <li v-if="store.getters['auth/getUserType'] == 'Admin'"><el-button :class="'add-btn excel'" @click="exportToExcel" :loading="isExport" type="plain"><font-awesome-icon icon="fa-solid fa-file-export" /> Export</el-button></li>
                                    <li >
                                        <el-button
                                            v-if="!isSearch"
                                            type="info"
                                            link
                                            @click="isSearch = !isSearch"
                                        >
                                            <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> Search
                                        </el-button>
                                        <el-input
                                            v-if="isSearch"
                                            v-model="searchValue"
                                            style="max-width: 300px"
                                            placeholder="Please input"
                                            class="input-with-select"
                                        >
                                        <template #append>
                                            <el-button style="width: 30px;" @click="searchUsers">
                                                <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
                                            </el-button>
                                        </template>
                                        </el-input>
                                    </li>
                                    

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                
                <el-table 
                    :row-class-name="tableRowClassName" 
                    v-loading="isTableLoading" 
                    element-loading-text="Loading..." 
                    element-loading-background="rgba(255, 255, 255, 0.8)" 
                    :data="leads.data" style="width: 100%" 
                    :header-row-class-name="'table-header-style'" 
                    :header-cell-class-name="'table-header-cell-style'" 
                    :highlight-current-row="true" 
                    :cell-class-name="'custom-cell'"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column type="selection" width="55"  fixed="left"/>
                    <el-table-column 
                        label="ID"  
                        width="80"
                        
                    >
                        <template #default="scope"> 
                            <el-link
                                type="primary"
                                :underline="false"
                                @click="scope.row.is_lead_show = true"
                            >
                                #{{ scope.row.id }}
                            </el-link>
                        </template>
                    </el-table-column>
                    
                    <el-table-column 
                        
                    min-width="150"
                    >
                        <template #header>
                            Client name
                            <FilterPopover
                            :filterKey="'client_name'"
                            :filters="filtersKeys"
                            @apply-filter="handleApplyFilter"
                            @toggle-popover="handleTogglePopover"
                            @cancle-popover="handleCanclePopover"
                            >
                                <!-- Additional content for the filter -->
                                <el-input v-model="filter_model.client_name" placeholder="Please input" />
                            </FilterPopover>

                        </template>

                        <template #default="scope">
                            {{  scope.row.client_name }}

                        </template>
                    </el-table-column>
                    <el-table-column 
                        
                        :show-overflow-tooltip="true"
                        min-width="150"
                    >
                    <template #header>
                        Email
                        <FilterPopover
                        :filterKey="'client_email'"
                        :filters="filtersKeys"
                        @apply-filter="handleApplyFilter"
                        @toggle-popover="handleTogglePopover"
                        @cancle-popover="handleCanclePopover"
                        >
                            <!-- Additional content for the filter -->
                            <el-input v-model="filter_model.client_email" placeholder="Please input" />
                        </FilterPopover>

                    </template>
                    <template #default="scope">
                        {{  scope.row.client_email }}

                    </template>
                    </el-table-column>
                    <el-table-column 
                        label="Phone" 
                        min-width="150"
                        :show-overflow-tooltip="true"
                    >
                        <template #header>
                            Phone
                            <FilterPopover
                            :filterKey="'client_number'"
                            :filters="filtersKeys"
                            @apply-filter="handleApplyFilter"
                            @toggle-popover="handleTogglePopover"
                            @cancle-popover="handleCanclePopover"
                            >
                                <!-- Additional content for the filter -->
                                <el-input v-model="filter_model.client_number" placeholder="Please input" />
                            </FilterPopover>

                        </template>
                        <template #default="scope">
                            <el-button  text circle @click="openWhatsApp(scope.row.client_number)">
                                <font-awesome-icon icon="fa-brands fa-square-whatsapp" size="xl" style="color: #008f64;" />
                            </el-button>
                            <a :href="`tel:${scope.row.client_number}`">
                                <el-button style="margin-left: 0px;  margin-right: 5px; background-color: #005980;  border: none; border-radius: 2px;  width: 18px; height: 18px;" circle>
                                    <font-awesome-icon icon="fa-solid fa-phone" size="xs" style="color: #fff;" />
                                </el-button>
                            </a>
                            {{  scope.row.client_number }}

                        </template>
                    </el-table-column>

                    <el-table-column 
                    
                        width="200"
                    >
                    <template #header>
                        Salesman
                        <FilterPopover
                            :filterKey="'salesman'"
                            :filters="filtersKeys"
                            @apply-filter="handleApplyFilter"
                            @toggle-popover="handleTogglePopover"
                            @cancle-popover="handleCanclePopover"
                        >
                            <el-select 
                                v-model="filter_model.user_id" 
                                placeholder="Please Select User"
                                filterable
                                :reserve-keyword="false"
                            >
                                <el-option 
                                    v-for="user in lists.usersToAssign"
                                    :key="user.id" 
                                    :label="user.first_name + ' ' + user.last_name" 
                                    :value="user.id" 
                                />
                                
                            </el-select>
                        </FilterPopover>

                    </template>
                    <template #default="scope">
                    <div style="display: flex; line-height: 10px; cursor: pointer;" @click="goToUserProfile(scope.row.user.id)">
                        <el-avatar
                        size="small"
                        src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
                        />
                        <div>
                        <h5 style="font-size: 12px; margin-bottom: 0;">{{ scope.row.user.first_name }} {{ scope.row.user.last_name }}</h5>
                        <span style="font-size: 10px; line-height: unset;">{{ scope.row.user.account_type }}</span>
                        </div>
                    </div>
                    
                    </template>

                    </el-table-column>
                    <el-table-column 
                    min-width="150"
                    >
                        <template #header>
                            Area
                            <FilterPopover
                            :filterKey="'city'"
                            :filters="filtersKeys"
                            @apply-filter="handleApplyFilter"
                            @toggle-popover="handleTogglePopover"
                            @cancle-popover="handleCanclePopover"
                            >
                                <!-- Additional content for the filter -->
                                <el-select 
                                    v-model="filter_model.area" 
                                    placeholder="Select Area"
                                    filterable
                                    default-first-option
                                    :reserve-keyword="false"
                                >
                                    <el-option
                                    v-for="city in lists.cities"
                                    :key="city.id"
                                    :label="city.name"
                                    :value="city.name"
                                    />
                                </el-select>
                            </FilterPopover>

                        </template>
                        <template #default="scope">
                            {{  scope.row.area }}

                        </template>
                    </el-table-column>
                    <el-table-column 
                    min-width="200"
                        
                    >
                        <template #header>
                            Stage
                            <FilterPopover
                            :filterKey="'stages'"
                            :filters="filtersKeys"
                            @apply-filter="handleApplyFilter"
                            @toggle-popover="handleTogglePopover"
                            @cancle-popover="handleCanclePopover"
                            >
                                <!-- Additional content for the filter -->
                                <el-select 
                                    v-model="filter_model.stage" 
                                    placeholder="Select Stage"
                                    filterable
                                    default-first-option
                                    :reserve-keyword="false"
                                >
                                    <el-option
                                    v-for="stage in lists.stages"
                                    :key="stage.id"
                                    :label="stage.name"
                                    :value="stage.name"
                                    />
                                </el-select>
                            </FilterPopover>

                        </template>
                        <template #default="scope">
                            <el-tag
                            
                            :type="scope.row.stage == 'Follow Up' ? 'warning' : 'primary'"
                            effect="light"
                            round
                            > 
                            {{  scope.row.stage }}
                        </el-tag>

                        </template>
                    </el-table-column>
                    <el-table-column 
                        label="Project" 
                        :show-overflow-tooltip="true"
                        min-width="150"
                    >
                        <template #header>
                            Project
                            <FilterPopover
                            :filterKey="'project_id'"
                            :filters="filtersKeys"
                            @apply-filter="handleApplyFilter"
                            @toggle-popover="handleTogglePopover"
                            @cancle-popover="handleCanclePopover"
                            >
                                <!-- Additional content for the filter -->
                                <el-select 
                                    v-model="filter_model.project_id" 
                                    placeholder="Select Project"
                                    filterable
                                    default-first-option
                                    :reserve-keyword="false"
                                >
                                    <el-option
                                    v-for="project in lists.projects"
                                    :key="project.id"
                                    :label="project.name"
                                    :value="project.id"
                                    />
                                </el-select>
                            </FilterPopover>

                        </template>
                        <template #default="scope">
                            {{  scope.row.project.name }}

                        </template>
                    </el-table-column>
                    
                    <el-table-column 
                        
                    min-width="120"
                    >
                        <template #header>
                            Channel
                            <FilterPopover
                                :filterKey="'channel'"
                                :filters="filtersKeys"
                                @apply-filter="handleApplyFilter"
                                @toggle-popover="handleTogglePopover"
                                @cancle-popover="handleCanclePopover"
                            >
                                <!-- Additional content for the filter -->
                                <el-select 
                                    v-model="filter_model.channel" 
                                    placeholder="Select Channel"
                                    filterable
                                    default-first-option
                                    :reserve-keyword="false"
                                >
                                    <el-option
                                        v-for="channel in lists.channels"
                                        :key="channel.id"
                                        :label="channel.name"
                                        :value="channel.name"
                                    />
                                </el-select>
                            </FilterPopover>

                        </template>
                    <template #default="scope">
                        
                        <el-tag
                            
                            :type="scope.row.registeration_type == 'Business' ? 'warning' : 'primary'"
                            effect="light"
                            round
                            > 
                            {{  scope.row.channel }}
                        </el-tag>
                    </template>
                    </el-table-column>
                    <el-table-column 
                    min-width="120"
                    >
                        <template #header>
                            Status
                            <FilterPopover
                                :filterKey="'status'"
                                :filters="filtersKeys"
                                @apply-filter="handleApplyFilter"
                                @toggle-popover="handleTogglePopover"
                                @cancle-popover="handleCanclePopover"
                            >
                                <!-- Additional content for the filter -->
                                <el-select 
                                    v-model="filter_model.status" 
                                    placeholder="Select Status"
                                    filterable
                                    default-first-option
                                    :reserve-keyword="false"
                                >
                                    <el-option
                                        v-for="statu in lists.status"
                                        :key="statu.id"
                                        :label="statu.name"
                                        :value="statu.name"
                                    />
                                </el-select>
                            </FilterPopover>

                        </template>
                        <template #default="scope">
                            <el-tag disable-transitions="true" round :type="scope.row.status == 'Fresh' ?'success':'primary'">{{scope.row.status}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" fixed="right" min-width="120">
                        <template #header>
                            Actions
                        </template>
                        <template #default="scope">
                            <el-button
                            size="small"
                            type="primary"
                            :icon="View" 
                            circle
                            
                            @click="showLead(scope.$index)"
                            />
                            <el-button
                            v-if="store.getters['auth/getUserRole'] == 'Admin'"
                            size="small"
                            type="danger"
                            :icon="Delete" 
                            circle
                            @click="deleteLead(scope.row.id)"
                            />
                        </template>
                    </el-table-column>
                </el-table>
                <!-- Show Lead Drawer  -->
                <el-drawer
                    v-for="lead , index in leads.data"
                    :key="lead.id"
                    v-model="lead.is_lead_show"
                    :direction="'rtl'"
                    :modal-class="'show-lead-drawer'"
                    :show-close="false"
                    :close-on-click-modal="!isUpdateLoading"
                    @close="handleLeadClose(index)"
                >
                    <template #header="{ close, titleId, titleClass }">
                        <!-- <h4 :id="titleId" :class="titleClass">This is a custom header!</h4>
                        <el-button type="danger" @click="close">
                            <el-icon class="el-icon--left"><CircleCloseFilled /></el-icon>
                            Close
                        </el-button> -->
                        
                    </template>
                    <div class="show-lead-header-body">
                        <div class="client-actions-side">
                            <!-- <img src="../assets/client2.png" alt="" srcset=""> -->
                            <div class="client-actions">
                                <el-button size="large" type="primary" circle >
                                    <a :href="`tel:${lead.client_number}`">

                                        <img src="../assets/telephone.png" alt="" srcset="">
                                    </a>
                                </el-button>
                                <el-button size="large" type="success" circle @click="openWhatsApp(lead.client_number)">
                                    <img src="../assets/whatsapp.png" alt="" srcset="">
                                </el-button>
                                <el-button size="large" type="danger" circle >
                                    <a :href="`mailto:${lead.client_email}`">

                                        <img src="../assets/mail.png" alt="" srcset="">
                                    </a>
                                </el-button>
                                <el-button size="large" type="warning"  circle >
                                    <img src="../assets/home.png" alt="" srcset="">
                                </el-button>
                                
                            </div>
                        </div>
                        <div class="client-info-side">
                            <h1>{{lead.client_name}}</h1>
                            <h5>{{lead.area}}</h5>
                            <span>{{lead.client_number}}</span>
                            <p>Created at : {{ lead.created_at }} </p>
                        </div>
                    </div>
                    <div class="show-lead-content-container">
                        <div class="taps-container">
                            <el-tabs type="border-card" class="demo-tabs">
                                <el-tab-pane>
                                    <template #label>
                                        <span class="custom-tabs-label">
                                            <span>Details</span>
                                        </span>
                                    </template>
                                    <div class="lead-info-container">
                                        <div class="info-actions-nav">
                                            <el-button v-if="!lead.is_lead_edit" @click="openEditForm(index)" size="large" type="primary" circle >
                                                <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                                            </el-button>
                                            <div class="update-form-actions-container">
                                                <el-button v-if="lead.is_lead_edit" :disabled="isUpdateLoading" @click=" handleLeadClose(index) " type="primary">
                                                    <font-awesome-icon icon="fa-solid fa-xmark" /> Cancel
                                                </el-button>
                                                <el-button :loading="isUpdateLoading" v-if="lead.is_lead_edit" type="success" @click="updateLead(index)">
                                                    <font-awesome-icon v-if="!isUpdateLoading" icon="fa-solid fa-arrow-up-from-bracket" />  Update
                                                </el-button>
                                            </div>
                                        </div>
                                        <el-descriptions title="Lead Information" column="2">
                                            <el-descriptions-item label="Lead Name">
                                                <span v-if="!lead.is_lead_edit">{{lead.client_name}}</span>
                                                <el-input :disabled="isUpdateLoading" v-model="LeadEditForm.client_name" style="width: 150px;" v-if="lead.is_lead_edit" placeholder="Please input" />
                                            </el-descriptions-item>
                                            <el-descriptions-item label="Area">
                                                
                                                <span v-if="!lead.is_lead_edit">{{lead.area}}</span>
                                                <el-select 
                                                    v-if="lead.is_lead_edit"
                                                    v-model="LeadEditForm.area" 
                                                    :disabled="isUpdateLoading"
                                                    placeholder="Select Area"
                                                    filterable
                                                    default-first-option
                                                    style="width: 150px;"
                                                    :reserve-keyword="false"
                                                >
                                                    <el-option
                                                    v-for="city in lists.cities"
                                                    :key="city.id"
                                                    :label="city.name"
                                                    :value="city.name"
                                                    />
                                                </el-select>
                                                <!-- <span class="edit-btn">
                                                    <font-awesome-icon icon="fa-solid fa-pen" />
                                                </span> -->
                                                <!-- <span class="close-edit">
                                                    <font-awesome-icon icon="fa-solid fa-xmark" />
                                                </span> -->
                                            </el-descriptions-item>
                                            <el-descriptions-item label="Telephone">
                                                <span v-if="!lead.is_lead_edit">{{lead.client_number}}</span>
                                                <el-input :disabled="isUpdateLoading" v-model="LeadEditForm.client_number" style="width: 150px;" v-if="lead.is_lead_edit" placeholder="Please input" />
                                            </el-descriptions-item>
                                            <el-descriptions-item label="Channal">
                                                <el-tag disable-transitions="true" size="small" v-if="!lead.is_lead_edit">{{lead.channel}}</el-tag>
                                                <el-select 
                                                    v-if="lead.is_lead_edit"
                                                    v-model="LeadEditForm.channel" 
                                                    :disabled="isUpdateLoading"
                                                    placeholder="Select Channal"
                                                    filterable
                                                    default-first-option
                                                    style="width: 150px;"
                                                    :reserve-keyword="false"
                                                >
                                                    <el-option
                                                        v-for="channel in lists.channels"
                                                        :key="channel.id"
                                                        :label="channel.name"
                                                        :value="channel.name"
                                                    />
                                                </el-select>
                                            </el-descriptions-item>
                                            <el-descriptions-item label="Stage">
                                                <el-tag v-if="!lead.is_lead_edit" disable-transitions="true" size="small" type="warning">{{lead.stage}}</el-tag>
                                                <el-select 
                                                    v-if="lead.is_lead_edit"
                                                    v-model="LeadEditForm.stage" 
                                                    :disabled="isUpdateLoading"
                                                    placeholder="Select Stage"
                                                    filterable
                                                    default-first-option
                                                    style="width: 150px;"
                                                    :reserve-keyword="false"
                                                >
                                                    <el-option
                                                        v-for="stage in lists.stages"
                                                        :key="stage.id"
                                                        :label="stage.name"
                                                        :value="stage.name"
                                                    />
                                                </el-select>
                                            </el-descriptions-item>
                                            <el-descriptions-item label="Project">
                                                <span v-if="!lead.is_lead_edit">{{lead.project.name}}</span>
                                                <el-select 
                                                    v-if="lead.is_lead_edit"
                                                    v-model="LeadEditForm.project_id" 
                                                    :disabled="isUpdateLoading"
                                                    placeholder="Select Project"
                                                    filterable
                                                    style="width: 150px;"
                                                    :reserve-keyword="false"
                                                >
                                                <el-option
                                                    v-for="project in lists.projects"
                                                    :key="project.id"
                                                    :label="project.name"
                                                    :value="project.id"
                                                />
                                                </el-select>
                                            </el-descriptions-item>
                                            
                                            <el-descriptions-item label="Unit Link">
                                                <el-link
                                                    v-if="!lead.is_lead_edit"
                                                    type="primary"
                                                    :underline="false"
                                                    style="max-width: 200px; text-overflow: ellipsis; overflow: hidden;"
                                                >
                                                    {{ lead.unit_link }}
                                                </el-link>
                                                <el-input
                                                    v-if="lead.is_lead_edit"
                                                    v-model="LeadEditForm.unit_link"
                                                    type="text"
                                                    style="width: 150px;"
                                                    :disabled="isUpdateLoading"
                                                    placeholder="unit link "
                                                    clearable
                                                />
                                            </el-descriptions-item>
                                            <el-descriptions-item label="Salesman">
                                                <span v-if="!lead.is_lead_edit || store.getters['auth/getUserRole'] !== 'Admin' && store.getters['auth/getUserRole'] !== 'Team Leader' ">{{lead.user.first_name}} {{lead.user.last_name}}</span>
                                                <el-select 
                                                    v-if="lead.is_lead_edit && store.getters['auth/getUserRole'] !== 'Sales'"
                                                    v-model="LeadEditForm.user_id" 
                                                    :disabled="isUpdateLoading"
                                                    placeholder="Assign User"
                                                    filterable
                                                    style="width: 150px;"
                                                    :reserve-keyword="false"
                                                >
                                                <el-option
                                                    v-for="member in lists.usersToAssign"
                                                    :key="member.id"
                                                    :label="member.first_name + ' ' +member.last_name"
                                                    :value="member.id"
                                                />
                                                </el-select>
                                            </el-descriptions-item>
                                            <el-descriptions-item label="Next Follow Up Date">
                                                <span v-if="!lead.is_lead_edit">{{formatDate(lead.next_followUp_date)}}</span>
                                                <el-date-picker
                                                    v-if="lead.is_lead_edit"
                                                    v-model="LeadEditForm.next_followUp_date"
                                                    :disabled="isUpdateLoading"
                                                    type="datetime"
                                                    value-format="YYYY-MM-DD HH:mm:ss"
                                                    placeholder="Select date and time"
                                                />
                                            </el-descriptions-item>
                                            <el-descriptions-item label="Status">
                                                <el-tag disable-transitions="true" size="small" v-if="!lead.is_lead_edit" :type="lead.status == 'Fresh' ?'success':'primary'">{{lead.status}}</el-tag>
                                                <el-select 
                                                    v-if="lead.is_lead_edit"
                                                    v-model="LeadEditForm.status" 
                                                    :disabled="isUpdateLoading"
                                                    placeholder="Select Statue"
                                                    filterable
                                                    default-first-option
                                                    style="width: 150px;"
                                                    :reserve-keyword="false"
                                                >
                                                <el-option
                                                    v-for="statu in lists.status"
                                                    :key="statu.id"
                                                    :label="statu.name"
                                                    :value="statu.name"
                                                />
                                                </el-select>
                                            </el-descriptions-item>
                                        </el-descriptions>
                                    </div>
                                </el-tab-pane>
                                
                                <el-tab-pane name="comments" >
                                    <template #label>
                                        <span class="custom-tabs-label">
                                            <span>Comments</span>
                                        </span>
                                    </template>
                                    <div class="main-comments-container">
                                        <div class="section-title">
                                            <div class="section-icon">
                                                <img src="../assets/comments.png" alt="" srcset="">
                                            </div>
                                            Lead Comments
                                        </div>
                                        <div class="comments-container" ref="messagesContainer">
                                            <TransitionGroup  name="slide-fade" tag="div">
                                                <div  class="comment" v-for="comment in comments" :key="comment.id">
                                                    <div class="user-photo">

                                                    </div>
                                                    <div class="content">
                                                        <div class="header">
                                                            <div>
                                                                <span class="name">{{comment.user.first_name + ' ' + comment.user.last_name}}</span>
                                                                <span class="date">{{ formatRelativeTime(comment.created_at) }}</span>
                                                            </div>
                                                            <span class="role">{{comment.user.account_type}}</span>
                                                        </div>
                                                        <div class="message">
                                                            <p>{{ comment.comment }}</p>
                                                        </div>
                                                        <div class="comment-actions">
                                                            <ul>
                                                                <li> 
                                                                    <el-popconfirm title="Are you sure to delete this comment ?" @confirm="deleteComment(comment.id)">
                                                                        <template #reference>
                                                                                <el-button size="large" round v-if="store.getters['auth/getUserRole'] == 'Admin'">
                                                                                    <el-icon><Delete /></el-icon>
                                                                                </el-button>
                                                                        </template>
                                                                    </el-popconfirm>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TransitionGroup >
                                        </div>
                                    </div>
                                    <div class="comment-input-container">
                                        <div class="comment-input">
                                            <div class="user-photo"></div>
                                            <div class="input-message">
                                                <el-input v-model="comment_model.comment" :disabled="isCommentLoading" type="textarea" :autosize="'false'" placeholder="Type Your Comment ." />
                                            </div>
                                            <div class="send-btn">
                                                <el-button :loading="isCommentLoading" :disabled="!comment_model.comment || comment_model.comment.trim() === ''"  @click="addComment(lead.id);">
                                                    <font-awesome-icon v-if="!isCommentLoading" icon="fa-solid fa-paper-plane" />
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane>
                                    <template #label>
                                        <span class="custom-tabs-label">
                                            <span>History</span>
                                        </span>
                                    </template>
                                    <div class="section-title">
                                        <div class="section-icon">
                                            <img src="../assets/history.png" alt="" srcset="">
                                        </div>
                                        Lead History
                                    </div>
                                    <div>
                                        <Actions :leadId="lead.id" />
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="Task">Task</el-tab-pane>
                            </el-tabs>
                        </div>
                    </div>
                </el-drawer>
                
                <el-drawer
                    v-model="isAdd"
                    :title="'Add Lead'"
                    :direction="'rtl'"
                    :modal-class="'add-project-modal-drawer'"
                    :before-close="handleAddLeadClose"
                >
                    <el-form
                        ref="ruleFormRef"
                        :model="add_model"
                        :rules="rules"
                        label-width="auto"
                        class="demo-ruleForm"
                        :label-position="'top'"
                        :size="'default'"
                        status-icon
                    >
                        <el-form-item prop="client_name" label="Name">
                            <el-input
                                v-model="add_model.client_name"
                                type="text"
                                placeholder="Client name "
                                clearable
                            />
                        </el-form-item>                 
                        <el-space fill>
                            <el-alert type="warning" show-icon :closable="false">
                                <p>"Client Number" Must Start With Country Key ex (+2) :</p>
                            </el-alert>
                            <el-form-item prop="client_number" label="Telephone">
                                <el-input
                                v-model="add_model.client_number"
                                type="text"
                                placeholder="phone"
                                clearable
                                />
                            </el-form-item>
                        </el-space>
                        <el-form-item prop="client_sec_number" label="2nd-Telephone">
                            <el-input
                                v-model="add_model.client_sec_number"
                                type="text"
                                placeholder="2nd phone"
                                clearable
                            />
                        </el-form-item>
                        <el-form-item prop="client_email" label="Email Address">
                            <el-input
                                v-model="add_model.client_email"
                                type="text"
                                placeholder="Email@example.com "
                                clearable
                            />
                        </el-form-item>
                        <el-form-item prop="project_id" label="Project">
                            <el-select
                                v-model="add_model.project_id"
                                filterable
                                default-first-option
                                :reserve-keyword="false"
                                placeholder="Project"
                                
                                >
                                <el-option
                                    v-for="project in lists.projects"
                                    :key="project.id"
                                    :label="project.name"
                                    :value="project.id"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="channel" label="Channels">
                            <el-select
                                v-model="add_model.channel"
                                filterable
                                default-first-option
                                :reserve-keyword="false"
                                placeholder="Channel"
                                
                                >
                                <el-option
                                    v-for="channel in lists.channels"
                                    :key="channel.id"
                                    :label="channel.name"
                                    :value="channel.name"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="area" label="Areas">
                            <el-select
                                v-model="add_model.area"
                                filterable
                                default-first-option
                                :reserve-keyword="false"
                                placeholder="Area"
                                
                                >
                                <el-option
                                    v-for="city in lists.cities"
                                    :key="city.id"
                                    :label="city.name"
                                    :value="city.name"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="stage" label="Stage">
                            <el-select
                                v-model="add_model.stage"
                                filterable
                                default-first-option
                                :reserve-keyword="false"
                                placeholder="Stage"
                                
                                >
                                <el-option
                                    v-for="stage in lists.stages"
                                    :key="stage.id"
                                    :label="stage.name"
                                    :value="stage.name"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="status" label="Status">
                            <el-select
                                v-model="add_model.status"
                                filterable
                                default-first-option
                                :reserve-keyword="false"
                                placeholder="Status"
                                
                                >
                                <el-option
                                    v-for="statu in lists.status"
                                    :key="statu.id"
                                    :label="statu.name"
                                    :value="statu.name"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Unit Link">
                            <el-input
                                v-model="add_model.unit_link"
                                type="text"
                                placeholder="unit link "
                                clearable
                            />
                        </el-form-item>
                        <el-form-item prop="next_followUp_date" label="Next Follow Up Date">
                            <el-date-picker
                                v-model="add_model.next_followUp_date"
                                type="datetime"
                                value-format="YYYY-MM-DD HH:mm:ss"
                                placeholder="Select date and time"
                            />
                        </el-form-item>
                        <el-form-item label="Asign To" v-if="store.getters['auth/getUserRole'] == 'Admin' || store.getters['auth/getUserRole'] == 'Team Leader'">
                            <el-select                    
                                v-model="add_model.user_id" 
                                :disabled="isAddFormLoading"
                                placeholder="Assign User"
                                filterable
                                
                                :reserve-keyword="false"
                            >
                            <el-option
                                v-for="member in lists.usersToAssign"
                                :key="member.id"
                                :label="member.first_name + ' ' +member.last_name"
                                :value="member.id"
                            />
                            </el-select>
                        </el-form-item>
                        
                        
                    </el-form>
                    <template #footer>
                        <div style="flex: auto">
                            
                            <el-button v-loading.fullscreen.lock="isAddFormLoading" @click="handleAddLeadClose">cancel</el-button>
                            <el-button type="primary" @click="handleAddSubmit">Add Lead</el-button>
                            
                        </div>
                    </template>
                </el-drawer>

                <div class="pagination-container">
                    <el-pagination
                    :page-size="leads.per_page"
                    :pager-count="11"
                    :size="'small'"
                    layout="prev, pager, next"
                    :total="leads.total"
                    :background="true"
                    :disabled="isPaginationDisabled"
                    :current-page="page"
                    @current-change="paginationChanged"
                    />
                </div>

            </div>
        </div>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { onMounted, ref , computed , reactive } from 'vue';
import { useStore } from 'vuex';
import dayjs from 'dayjs';
import { useRouter } from 'vue-router';
import Actions from '@/components/actions.vue';
import FilterPopover from '../components/filterPopover.vue';
import { formatRelativeTime } from "@/utils/time";
import service from '@/utils/request';
import {
  ArrowRight,
  CaretBottom,
  CaretTop,
  Check,
  Warning,
  Delete,
  Edit,
  Close,
  View,
  Message,
  Phone,
} from '@element-plus/icons-vue'
import GridStatistics from '@/components/grid-statistics.vue';
import { getAllReports } from '@/api/reports';
import * as XLSX from 'xlsx';
export default {
    name: 'Leads',
    components: {
        Actions,
        FilterPopover,
        GridStatistics,
    },
    setup() {
        const colorList = [
        '#055866', // Main Color: Deep Teal
        '#1ABC9C', // Dark Teal (Similar to main color but brighter for accents)
        '#16A085', // Teal (Slightly more vibrant for highlights)
        '#2C3E50', // Dark Slate Blue (Deep contrast for headers or important elements)
        '#8E44AD', // Purple (For rich, modern accents)
        '#27AE60', // Dark Green (Subtle, earthy, complements teal nicely)
        '#F39C12', // Dark Gold (To add warmth and highlight CTAs)
        '#E74C3C', // Crimson Red (For emphasis, alerts, or callouts)
        '#BDC3C7', // Light Gray (Neutral, soft background or text)
        '#ECF0F1', // Very Light Gray (Background color or for contrast with text)
        '#D35400', // Dark Orange (For buttons, highlights, or to grab attention)
        '#34495E', // Charcoal Gray (Professional, sophisticated dark accent)
        ];





        const statisitcs = ref([]);
        const leads = ref([]);
        const LeadEditForm = ref({});
        const isLeadsFilter = ref(false);
        const isAddFormLoading = ref(false);
        const filterKey = ref('All Leads');
        const isAdd = ref(false);
        const filtersKeys = ref({
            city:{
                title:'Filter Area' ,
                isFilter:false,
            },
            project_id:{
                title:'Filter Project' ,
                isFilter:false,
            },
            client_name:{
                title:'Filter client name' ,
                isFilter:false,
            },
            client_number:{
                title:'Filter client number' ,
                isFilter:false,
            },
            client_email:{
                title:'Filter with email' ,
                isFilter:false,
            },
            status:{
                title:'Filter Status' ,
                isFilter:false,
            },
            channel:{
                title:'Filter Channel' ,
                isFilter:false,
            },
            stages:{
                title:'Filter Stage' ,
                isFilter:false,
            },
            salesman:{
                title:'Filter Salesman' ,
                isFilter:false,
            }
        });
        const editableKeys = [
            "id",
            "client_name",
            "client_number",
            "client_email",
            "user_id",
            "project_id",
            "channel",
            "area",
            "stage",
            "status",
            "unit_link",
            "next_followUp_date",
        ];
        const add_model = reactive({
            client_email: null,
            client_name: null,
            client_number: null,
            client_sec_number: null,
            project_id: null,
            action_type: null,
            channel: null,
            area: null,
            stage: null,
            status: null,
            user_id:null,
            unit_link:null,
            next_followUp_date: null,
        });
        const rules = reactive({
            client_name: [
                { required: true, message: '@Required', trigger: 'blur' },   
            ],
            client_number: [
                { required: true, message: '@Required', trigger: 'blur' }, 
                {
                    validator: (rule, value) => {
                        const phoneRegex = /^[+]?[0-9]*$/; // Allows numbers with optional leading '+'
                        if (value && !phoneRegex.test(value)) {
                            return new Error('Please enter a valid phone number without spaces (numbers only, with optional "+" at the beginning).');
                        }
                        return true;
                    },
                    trigger: 'blur',
                },  
            ],       
            client_sec_number:[
                {
                    required:false,
                    trigger: 'blur'
                },
                {
                    validator: (rule, value) => {
                        const phoneRegex = /^[+]?[0-9]*$/; // Allows numbers with optional leading '+'
                        if (value && !phoneRegex.test(value)) {
                            return new Error('Please enter a valid phone number without spaces (numbers only, with optional "+" at the beginning).');
                        }
                        return true;
                    },
                    trigger: 'blur',
                },
            ],   
            client_email: [
                {
                required: false,
                trigger: 'blur',
                },
                {
                validator: (rule, value) => {
                    
                    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                    if (!emailRegex.test(value) && value != null && value != '') {
                        return new Error('Please enter a valid email address.');
                    }
                    return true;
                },
                trigger: 'blur',
                },
            ],
            project_id: [
                { required: true, message: '@Required', trigger: 'blur' },   
            ],
            action_type: [
                { required: true, message: '@Required', trigger: 'blur' },   
            ],
            channel: [
                { required: true, message: '@Required', trigger: 'blur' },   
            ],
            area: [
                { required: true, message: '@Required', trigger: 'blur' },   
            ],
            stage: [
                { required: true, message: '@Required', trigger: 'blur' },   
            ],
            status: [
                { required: true, message: '@Required', trigger: 'blur' },   
            ],
            next_followUp_date: [
                { required: true, message: '@Required', trigger: 'blur' },   
            ],
        });
        const page = ref(1);
        const store = useStore();
        const router = useRouter();
        const isUserActionsOpen = ref(true);
        const isTableLoading = ref(false);
        const isLoading = ref(false);
        const searchValue = ref(null);
        const lists = ref({});
        const isPaginationDisabled = ref(false);
        const isUpdateLoading = ref(false);
        const ruleFormRef = ref(null);
        const filter_model = reactive({
            client_email: null,
            client_name: null,
            client_number: null,
            project_id: null,
            action_type: null,
            channel: null,
            area: null,
            stage: null,
            status: null,
            next_followUp_date: null,
            isduplicate: null,
            user_id:null,
        });
        
        //comments
        const comment = ref({
                lead_id:null,
                message:null,
        });
        const messagesContainer = ref(null);
        const comment_model = reactive({
            lead_id:null,
            comment:null,
        });
        const comments = ref(null);
        const isCommentLoading = ref(false);
        const addComment = async (lead_id) => {
            isCommentLoading.value = true;
            comment_model.lead_id = lead_id;
            await store.dispatch('comments/addNewComment' , comment_model);
            comment_model.comment = null;
            comment_model.lead_id = null;
            comments.value = store.getters['comments/getComments'];
            isCommentLoading.value = false;
            await nextTick(); // ننتظر تحديث الـ DOM
            if (messagesContainer.value) {
                messagesContainer.value[0].scrollTop = messagesContainer.value[0].scrollHeight;
            }
            
        };
        const deleteComment = async (commentId) => {
            await store.dispatch('comments/deleteComment' , commentId);
            ElMessage({
                type: 'success',
                message: 'Deleted Successfully',
            })
            comments.value = store.getters['comments/getComments'];
        }
        const tapChanged = async(tab) => {
            if (tab === "comments") {
                await nextTick(); // ننتظر تحديث الـ DOM
                if (messagesContainer.value) {
                    messagesContainer.value[0].scrollTop = messagesContainer.value[0].scrollHeight;
                }
            }
        };
        // get lead comments on show lead drawer open
        const showLead = async (index) => {
            comments.value = [];
            leads.value.data[index].is_lead_show = true;
            const lead_id = leads.value.data[index].id;
            await store.dispatch('comments/fetchCommentsByLead' , lead_id );
            comments.value = store.getters['comments/getComments'];
        };

        //=========================================================


        const goToUserProfile = (id) => {
            router.push('/profile/'+id);
        }
        const refreshLeads = async (key , userid) => {

            isTableLoading.value = true;
            Object.keys(filter_model).forEach(key => {
                filter_model[key] = null; // استخدام $set لضمان التفاعل مع Vue
            });
            page.value = 1;
            if(key == "all"){
                filterKey.value = "All Leads";
                
                isLeadsFilter.value = false;
                const role = store.getters['auth/getUserRole'];
                const adminId = store.getters['auth/getUserId'];
                
                await store.dispatch('leads/fetchLeads' , page.value);
                
                lists.value = store.getters['leads/getLists'];
                leads.value = store.getters['leads/getLeads'];
                statisitcs.value = await getAllReports();
                
            }else{
                isLeadsFilter.value = true;
                if(userid){
                    filter_model.user_id = userId.value;
                    filterKey.value = user.value.first_name + ' ' + user.value.last_name;
                    
                }else{
                    filter_model.isduplicate = 1;

                    filterKey.value = "Duplicated";
                }
                
                await store.dispatch('leads/filter' , {form:filter_model , page:page.value});
                leads.value = store.getters['leads/getLeads'];
                lists.value = store.getters['leads/getLists'];
                statisitcs.value = store.getters['leads/getStatistics'];
                page.value = 1;
            }
            isTableLoading.value = false;
        }
        const handleLeadClose = (index) => {
            if(leads.value.data[index].is_lead_edit){
                ElMessageBox.confirm(
                    'You have unsaved changes, save and proceed?',
                    'Warning',
                    {
                        distinguishCancelAndClose: true,
                        cancelButtonText: 'Cancel',
                        confirmButtonText: 'Discard Changes',
                        type: 'warning',
                    }
                )
                .then(() => {
                    
                    leads.value.data[index].is_lead_edit = false;
                    LeadEditForm.value = {};
                    ElMessage({
                        type: 'warning',
                        message: 'Changes Discribed',
                    })
                })
                .catch(() => {
                    leads.value.data[index].is_lead_show = true;
                    ElMessage({
                        type: 'info',
                        message:'Canceld',
                    })
                })
            }else{
                leads.value.data[index].is_lead_show = false;
            }
        };
        
        const openEditForm = (index) => {
            LeadEditForm.value = Object.fromEntries(
                Object.entries(leads.value.data[index]).filter(([key]) => editableKeys.includes(key))
            );
            leads.value.data[index].is_lead_edit = true;
        };
        const openAddForm = () => {
            add_model.client_name , add_model.client_number , add_model.client_email , add_model.project_id , add_model.action_type , add_model.channel , add_model.stage , add_model.status , add_model.next_followUp_date , add_model.area= null;
            isAdd.value = true;
        };
        const deleteLead = (id) => {
            
            ElMessageBox.confirm(
                'Are you sure delete the Lead. Continue?',
                'Warning',
                {
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel',
                    type: 'warning',
                }
                )
                .then( async () => {
                    isTableLoading.value = true;
                    await store.dispatch('leads/deleteLead' , id);
                    leads.value = store.getters['leads/getLeads'];
                    isTableLoading.value = false;
                ElMessage({
                    type: 'success',
                    message: 'Delete successfull',
                })
                    /* units.value = store.getters['units/getUnits'];
                    isLoading.value = false; */
                })
                .catch(() => {
                    ElMessage({
                        type: 'info',
                        message: 'Delete canceled',
                    })
            })
        };
        const updateLead =  async (index) => {
            isUpdateLoading.value = true;
            await store.dispatch('leads/updateLead' , LeadEditForm.value);
            leads.value = store.getters['leads/getLeads'];
            ElMessage({
                type: 'success',
                message: 'Lead Updated Successfully',
            })
            leads.value.data[index].is_lead_edit = false;
            isUpdateLoading.value = false;
        }
        onMounted(async () => {
            isTableLoading.value = true;
            
            statisitcs.value = await getAllReports();
            await store.dispatch('leads/fetchLeads' , page.value);
            lists.value = store.getters['leads/getLists'];
            leads.value = store.getters['leads/getLeads'];
            isTableLoading.value = false;
        });
        const paginationChanged = async (value) => {
            page.value= value;
            isTableLoading.value = true;
            isPaginationDisabled.value = true;
            if(isLeadsFilter.value){
                await store.dispatch('leads/filter' , {form:filter_model , page:page.value});
            }else{
                await store.dispatch('leads/fetchLeads' , page.value);
            }
            lists.value = store.getters['leads/getLists'];
            leads.value = store.getters['leads/getLeads'];
            isPaginationDisabled.value = false;
            isTableLoading.value = false;
            isLoading.value = false;
        };
        const formatDate = (cellValue) => {
            if(cellValue){
                return dayjs(cellValue).format('YYYY-MM-DD'); // Formats date as YYYY-MM-DD
            }else{
                return "Undefind"
            }
        };
        const handleApplyFilter = async () => {
            page.value = 1;
            isLeadsFilter.value = true;
            isTableLoading.value = true;
            await store.dispatch('leads/filter' , {form:filter_model , page:page.value});
            leads.value = store.getters['leads/getLeads'];
            statisitcs.value = store.getters['leads/getStatistics'];
            isTableLoading.value = false;
        };
        const handleTogglePopover = (filterKey) => {
            for (const key in filtersKeys.value) {
            if (key !== filterKey) {
                filtersKeys.value[key].isFilter = false;
            }
            }
        };
        const handleCanclePopover = (filterKey) => {
            filter_model[filterKey] = null;
        };
        const openWhatsApp = (  cellValue ) => {
            const message = ``;
            
            const url = `https://wa.me/${cellValue}?text=${encodeURIComponent(message)}`;
            window.open(url, '_blank');  // Opens WhatsApp in a new tab or app
        };
        const resetForm = () => {
            const form = ruleFormRef.value; // Access the form instance
            if (!form) return;

            // Reset the form fields
            form.resetFields();
        };
        const handleAddLeadClose = () => {
            ElMessageBox.confirm(
            'You have unsaved changes, save and proceed?',
            'Confirm',
            {
            distinguishCancelAndClose: true,
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Discard Changes',
            }
        )
            .then(() => {
            isAdd.value = false;
            resetForm();
            ElMessage({
                type: 'info',
                message: 'Changes Discribed',
            })
            })
            .catch(() => {
            
            ElMessage({
                type: 'info',
                message:'Canceld',
            })
            })
            
        };
        const handleAddSubmit = async () => {
            const form = ruleFormRef.value; // Access the form instance
            if (!form) return;
                // Validate the form
                await form.validate(async (valid, fields) => {
                    if (valid) {
                        try {
                            isAddFormLoading.value = true;
                            // Send the form data to the store's action
                            await store.dispatch('leads/addNewLead', add_model);
                            resetForm();
                            
                            isAdd.value = false;
                            ElMessage({
                                type: 'success',
                                message: 'User is Added Successfully',
                            })
                            
                        } catch (error) {
                            ElMessage({
                            type: 'error',
                            message: 'Something Went Wrong ...',
                            })
                        } finally {
                            isAddFormLoading.value = false;
                        }
                    } else {
                        console.log('Form is invalid:', fields);
                    }
                }
            );
        };
        
        
        // handle Lead Selection 
        const selectedLeads = ref([]);
        const handleSelectionChange = async (val) => {
            selectedLeads.value = val;
        }
        //================================================

        const isExport = ref(false);
        
        const exportToExcel = async () => {
            isExport.value = true;
            const data = await fetchDataToExcel();
            
            const attributeMapping = {
            'Client Name': 'client_name',
            'Client Number': 'client_number',
            'Client Secondary Number': 'client_sec_number',
            'Client Email': 'client_email',
            'Salesman': 'username',
            'Project': 'project_name',
            'Unit Link': 'unit_link',
            'Channel': 'channel',
            'Area': 'area',
            'Stage': 'stage',
            'Status': 'status',
            'Next Follow Up Date': 'next_followUp_date',
            'Timestamp':'created_at',
            'Is Duplicate': 'isduplicate',
            'Last Comment':'last_comment_message',
            };
            
            const columnOrder = [
            'Timestamp','Client Name', 'Client Number', 'Client Secondary Number', 'Client Email', 'Salesman', 'Project', 'Unit Link',
             'Channel', 'Area', 'Stage', 'Status', 'Next Follow Up Date', 'Is Duplicate' , 'Last Comment'
            ];
            
            const filteredData = data.map(item => {
            const filteredItem = {};
            columnOrder.forEach(attr => {
                const apiAttribute = attributeMapping[attr];
                if (apiAttribute) {
                if (apiAttribute.includes('.')) {
                    const keys = apiAttribute.split('.');
                    filteredItem[attr] = keys.reduce((acc, key) => acc[key], item);
                } else {
                    let value = item[apiAttribute];
                    if (value && ['next_followUp_date', 'created_at'].includes(apiAttribute)) {
                    // Formatting date fields
                    value = new Date(value).toISOString().split('T')[0];
                    }
                    filteredItem[attr] = value;
                }
                }
            });
            return filteredItem;
            });

            const worksheet = XLSX.utils.json_to_sheet(filteredData);
            const currentDate = new Date().toISOString().split('T')[0];
            const fileName = `${currentDate}_leads.xlsx`;

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads Data');
            XLSX.writeFile(workbook, fileName);
            isExport.value = false;
        };

        const fetchDataToExcel = async () => {
            try {
            const response = await service.get('https://tapegypt.com/api/export-leads');
            
            return response;
            } catch (error) {
            console.error('Error fetching data:', error);
            return [];
            }
        };

        return {
            fetchDataToExcel,
            exportToExcel,
            isExport,
            colorList,
            statisitcs,
            handleSelectionChange,
            selectedLeads,
            page,
            isAdd,
            filterKey,
            openWhatsApp,
            resetForm,
            openAddForm,
            add_model,
            ruleFormRef,
            goToUserProfile,
            handleAddLeadClose,
            handleAddSubmit,
            handleTogglePopover,
            handleCanclePopover,
            filtersKeys,
            filter_model,
            refreshLeads,
            paginationChanged,
            isPaginationDisabled,
            handleApplyFilter,
            isLeadsFilter,
            updateLead,
            formatDate,
            rules,
            isUpdateLoading,
            searchValue,
            LeadEditForm,
            openEditForm,
            deleteLead,
            lists,
            isLoading,
            leads,
            editableKeys,
            isAddFormLoading,
            store,
            router,
            isUserActionsOpen,
            isTableLoading,
            handleLeadClose,
            showLead,
            ArrowRight,
            CaretBottom,
            CaretTop,
            Check,
            Warning,
            Delete,
            Edit,
            Close,
            View,
            Phone,
            comment,
            messagesContainer,
            comment_model,
            deleteComment,
            isCommentLoading,
            tapChanged,
            addComment,
            comments,
            formatRelativeTime,
        }
    }
}

</script>


<style>
@import '../assets/styles/table.scss';
</style>
<style lang="scss">
        .leads-main-container{
            .statistics-main-container{
                
                width: 100%;
                //background-color: #cfdced;
                border-radius: 10px;
                //box-shadow: 0px 0px 30px -20px #816bff;
                .demo{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: space-between;
                    margin-top: 25px;
                    flex-wrap: wrap;
                    gap: 15px;
                    //padding: 0px 25px;
                }
            }
            .leads-main-table{
                min-height: calc(100% - 285px);
                width: 100%;
                margin-top: 15px;
                .assign_btn{
                    background-color: rgb(58, 121, 255) !important;
                    color: #fff !important;
                }
                .show-lead-drawer{
                    @media (max-width:761px){
                        .el-drawer{
                            width: 100% !important;
                        }
                    }
                    @media (min-width:762px){
                        .el-drawer{
                            width: 90% !important;
                        }
                    }
                    @media (min-width:992px){
                        .el-drawer{
                            width: 50% !important;
                        }
                    }
                    @media (min-width:1400px){
                        .el-drawer{
                            width: 40% !important;
                        }
                    }
                    .el-drawer__header{
                        display: none !important;
                    }
                    .el-drawer{
                        background-color: rgb(238 249 255);
                        overflow-y: scroll;
                        &::-webkit-scrollbar {
                            width: 0px;
                            transition: 0.2s ease-in-out;
                        }
                        .show-lead-header-body{
                            display: flex;
                            height: 250px;
                            .client-actions-side{
                                width: 32%;
                                position: relative;
                                display: flex;
                                overflow: hidden;
                                background-image: url('../assets/client.png');
                                background-size: contain;
                                background-repeat: no-repeat;
                                background-position: center;
                                img{
                                    margin: auto;
                                    height: 115%;
                                }
                                .client-actions{
                                    position: absolute;
                                    left: 0;
                                    bottom: 20px;
                                    width: 100%;
                                    display: flex;
                                    justify-content: center;
                                    button{
                                        padding: 1px;
                                        border: 0;
                                        img{
                                            width: 100%;
                                            height: 100%;
                                        }
                                    }
                                }
                            }
                            .client-info-side{
                                width: 63%;
                                
                                padding: 25px 15px 50px;
                                text-transform: capitalize;
                                h1{
                                    font-weight: 300;
                                }
                                span{
                                    font-size: 14px;
                                }
                                p{
                                    font-size: 12px;
                                }
                            }
                        }
                        .show-lead-content-container{
                            .taps-container{
                                .el-tabs {
                                    position: absolute;
                                    width: 100%;
                                    left: 0;
                                    min-height: calc(100% - 270px);
                                    border-top-left-radius: 30px;
                                    border-top-right-radius: 30px;
                                    box-shadow: 0px 25px 50px 6px #66829f;
                                    background: rgba(255, 255, 255, 0.75) !important;
                                    .el-tabs__header {
                                        position: absolute;
                                        width: 66%;
                                        right: 0px;
                                        top: -39px;
                                        background: none;
                                        border: none ;
                                        .el-tabs__item {
                                            justify-content: space-around;
                                            border: none !important;
                                            border-top-left-radius: 25px;
                                            border-top-right-radius: 25px;
                                            
                                            padding: 0px 15px;
                                            min-width: 30px;
                                            &:hover{
                                                color: #006080;
                                            }
                                            transition: 0.3s ease-in-out;
                                        }
                                        .is-active{
                                            padding: 10px 10px 5px;
                                            min-width: 100px;
                                            border: none ;
                                            color: #006080;
                                            font-weight: 700;
                                            transition: 0.3s ease-in-out;
                                        }
                                        span{
                                            width: 100%;
                                            display: flex;
                                            align-items: center;
                                            justify-content: space-around;
                                        }
                                    }
                                    .el-tabs__content{
                                        padding: 25px 30px;
                                        position: relative;
                                        .info-actions-nav{
                                            position: absolute;
                                            top: 8px;
                                            right: 8px;
                                            
                                            border-radius: 40px;
                                            button{
                                                transition: 0.2s ease-in-out;
                                                box-shadow: -5px 7px 10px -9px #00588b;
                                                &:hover{
                                                    color: #fff;
                                                    transition: 0.2s ease-in-out;
                                                }
                                            }
                                            .update-form-actions-container{
                                                width: 195px;
                                                position: absolute;
                                                right: 6px;
                                                top: 13px;
                                                svg{
                                                    margin-right: 5px;
                                                }
                                            }
                                        }
                                        .el-descriptions__header{
                                            margin-bottom: 35px;
                                        }
                                        .el-descriptions__body{
                                            background-color: transparent;
                                        }
                                        .el-descriptions__cell{
                                            position: relative;
                                            
                                            padding-bottom: 25px;
                                            .el-descriptions__label{
                                                font-weight: 600;
                                            }
                                            .edit-btn{
                                                opacity: 0;
                                                position: absolute;
                                                right: 25px;
                                                cursor: pointer;
                                                width: 25px;
                                                height: 25px;
                                                text-align: center;
                                                transition: 0.2s ease-in-out;
                                                &:hover{
                                                    color: #006080;
                                                    transition: 0.2s ease-in-out;
                                                }
                                            }
                                            &:hover{
                                                .edit-btn{
                                                    opacity: 1;
                                                }
                                            }
                                        }
                                    }
                                    .section-title{
                                        display: flex;
                                        gap: 10px;
                                        align-items: center;
                                        margin-bottom: 20px;
                                        font-weight: bold;
                                        .section-icon{
                                            width: 35px;
                                            height: 35px;
                                            overflow: hidden;
                                            background-color: #2674e250;
                                            border-radius: 100%;
                                            padding: 5px;
                                            display: flex;
                                        
                                            align-items: center;
                                            justify-content: center;
                                            img{
                                                width: 100%;
                                                height: 100%;
                                            }
                                        }
                                    }
                                    .main-comments-container{
                                        width: 100%;
                                        position: relative;
                                        .section-title{
                                            display: flex;
                                            gap: 10px;
                                            align-items: center;
                                            margin-bottom: 20px;
                                            font-weight: bold;
                                            .section-icon{
                                                width: 35px;
                                                height: 35px;
                                                overflow: hidden;
                                                background-color: #2674e250;
                                                border-radius: 100%;
                                                padding: 5px;
                                                display: flex;
                                            
                                                align-items: center;
                                                justify-content: center;
                                                img{
                                                    width: 100%;
                                                    height: 100%;
                                                }
                                            }
                                        }
                                        .comments-container{
                                            width: 100%;
                                            height: 500px;
                                            overflow-y: scroll;
                                            position: relative;
                                            //border-left: solid 2px #ddd;
                                            //border-bottom: solid 2px #ddd;
                                            border-radius: 20px;      
                                            .comment{
                                                width: 100%;
                                                
                                                padding: 15px;
                                                border-radius: 18px;
                                                display: flex;
                                                gap: 15px;
                                                margin-bottom: 5px;
                                                position: relative;
                                                /* &::before{
                                                    content: " ";
                                                    width: 35px;
                                                    height: 2px;
                                                    background-color: #ddd;
                                                    position: absolute;
                                                    left: 0;
                                                    top: 40px;
                                                } */
                                                .user-photo{
                                                    width: 40px;
                                                    height: 40px;
                                                    border-radius: 100%;
                                                    background-color: #00588b;
                                                    position: relative;
                                                    z-index: 10;
                                                    border: solid 1px #747474;
                                                    background: url('../assets/user3.png');
                                                    background-size: cover;
                                                }
                                                .content{
                                                    width: calc(100% - 60px);
                                                    .header{
                                                        width: 100%;

                                                        .name{
                                                            font-weight: bold;
                                                            margin-right: 10px;
                                                        }
                                                        .date{
                                                            font-size: 12px;
                                                        }
                                                        .role{
                                                            font-size: 12px;
                                                        }
                                                    }
                                                    .message{
                                                        border: solid 1px #e3e3e3;
                                                        padding: 15px;
                                                        margin-top: 10px;
                                                        border-radius: 20px;
                                                        box-shadow: -14px 13px 20px -23px #009fff;
                                                    }
                                                    .comment-actions{
                                                        position: absolute;
                                                        right: 26px;
                                                        bottom: 21px;
                                                        border-radius: 20px;
                                                        ul{
                                                            padding: 0;
                                                            margin: 0;
                                                            padding: 5px;
                                                            list-style: none;
                                                            display: flex;
                                                            li{
                                                                width: 30px;
                                                                height: 30px;
                                                                border-radius: 100%;
                                                                button{
                                                                    width: 30px;
                                                                    height: 30px;
                                                                    border: 0;
                                                                    padding: 0;
                                                                    border-radius: 100%;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    .comment-input-container{
                                        width: 100%;
                                        height: 50px;
                                        position: relative;
                                        //top: -25px;
                                        //padding-left:20px;
                                        .comment-input{
                                            width: 100%;
                                            height: 50px;
                                            padding: 5px;
                                            background-color: #fff;
                                            border-radius: 25px;
                                            position: relative;
                                            z-index: 999;
                                            box-shadow: -9px 4px 20px -15px #009fff;
                                            display: flex;
                                            align-items: center;
                                            gap: 10px;
                                            .user-photo{
                                                width: 40px;
                                                height: 40px;
                                                border-radius: 100%;
                                                background-color: #00588b;
                                            }
                                            .input-message{
                                                
                                                width: calc(100% - 100px);
                                                .el-textarea__inner{
                                                    box-shadow: none;
                                                }
                                            }
                                            .send-btn{
                                                width: 40px;
                                                height: 40px;
                                                border-radius: 100%;
                                                button{
                                                    width: 100%;
                                                    height: 100%;
                                                    border: 0;
                                                    border-radius: 100%;
                                                    background-color: none;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }   
                }
            }
        }
</style>